




























































import { Component, Vue, Watch, Mixins } from 'vue-property-decorator';
import { Mutations, Actions, Tabs, Views, ViewModes } from '@/ts/store/Constants';
import DeviceMethods from '@/mixins/DeviceMethods.vue';
import MobileOptionsFeed from '@/components/Options/MobileOptionsFeed.vue';
import MobileOptionsPriceSummary from '@/components/Options/MobileOptionsPriceSummary.vue';
import MobileSingleOption from '@/components/Options/MobileSingleOption.vue';
import MobileOptionsSelectedOptions from '@/components/Options/MobileOptionsSelectedOptions.vue';
import OptionsData from '@/ts/OptionsData';


@Component({
    components: {
        MobileOptionsFeed,
        MobileOptionsPriceSummary,
        MobileSingleOption,
        MobileOptionsSelectedOptions,
    },
})
export default class Options extends Mixins(DeviceMethods) {


     // Lifetime hooks
    constructor() {
        super();
    }

    public selectDefaultOption() {
        this.getTempData.filter((item: OptionsData) => {
            if (item.defaultOption === 0) {
                this.selectItem(item.id);
            }
        });
    }

    public beforeMount() {
        this.selectDefaultOption();
    }

    public selectItem(firstParameter: any) {
        this.$store.commit(Mutations.SELECT_ITEM, firstParameter);
    }

    public beforeCreate() {
        this.$store.commit(Mutations.SET_HEADER_TEXT, Vue.i18n.translate('header.options', 'Options') );
        this.$store.commit(Mutations.SET_RIGHT_HEADER_BUTTON, '');
    }

    public beforeUpdate() {
        this.$store.commit(Mutations.SET_HEADER_TEXT, Vue.i18n.translate('header.options', 'Options'));
        this.$store.commit(Mutations.SET_RIGHT_HEADER_BUTTON, '');
    }

    public created() {
        this.$store.dispatch(Actions.FETCH_OPTIONS);

        this.$store.commit(Mutations.SET_VIEW, {
            view: Views.Options, 
            viewMode: ViewModes.Options.All,
        });
    }

    get view() {
        return this.$store.getters['Viewport/getCurrentView'];
    }

    get allOptionsView() {
        return (this.view.viewMode === ViewModes.Options.All);
    }

    get singleOptionView() {
        return (this.view.viewMode === ViewModes.Options.SingleOptionView);
    }

    get yourOptionsView() {
        return (this.view.viewMode === ViewModes.Options.YourOptionsView);
    }

    get getTempData(): any {
        return this.$store.getters['Options/allOptions'];
    }

    get selectedOptions(): any {
        return this.$store.getters['Options/selectedOptions'];
    }

    get activeOption() {
        return this.$store.getters['Options/getActiveOption'];
    }
        
}
